<svg
  id="eeSwVTfp8da1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 400 400"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
>
  <g id="eeSwVTfp8da2_ts" transform="translate(200.000008,244.050003) scale(0,0)">
    <g transform="translate(-200.000008,-244.050003)">
      <path
        d="M284.2,308.5h-168.4c-4.4,0-7.9-3.6-7.9-7.9v-113c0-4.4,3.6-7.9,7.9-7.9h168.4c4.4,0,7.9,3.6,7.9,7.9v113c0,4.3-3.5,7.9-7.9,7.9Z"
        fill="#fbba3e"
      />
      <rect width="42.5" height="128.9" rx="0" ry="0" transform="translate(177.3 179.6)" fill="#67ad5c" />
    </g>
  </g>
  <g id="eeSwVTfp8da5_to" transform="translate(200.000008,-53.458746)">
    <g id="eeSwVTfp8da5_ts" transform="scale(0,0)">
      <g transform="translate(-200.000008,-140.722053)">
        <g id="eeSwVTfp8da6_tr" transform="translate(199.938553,149.666222) rotate(8)">
          <g transform="translate(-199.938553,-142.709125)">
            <path
              d="M132.5,134.6c0,0-42.2-27.9-8.4-55.4s68,4.8,72.6,23.1c4.7,18.3,2.9,32.3,2.9,32.3h-67.1Zm57,0c0,0,0-18.9-9.4-33s-41.2-20.4-47.1,0s22.4,33,22.4,33"
              fill="#72ba63"
            />
          </g>
        </g>
        <g id="eeSwVTfp8da8_tr" transform="translate(200,145.871442) rotate(-8)">
          <g transform="translate(-200,-138.914345)">
            <path
              d="M200.3,134.6c0,0-1.8-14.1,2.9-32.3c4.7-18.3,38.9-50.6,72.6-23.1s-8.4,55.4-8.4,55.4h-67.1Zm44.2,0c0,0,28.3-12.6,22.4-33s-37.7-14.1-47.1,0-9.4,33-9.4,33"
              fill="#72ba63"
            />
          </g>
        </g>
        <g id="eeSwVTfp8da10" opacity="0">
          <rect
            width="184.3"
            height="22"
            rx="0"
            ry="0"
            transform="translate(107.8 190.9)"
            opacity="0.03"
            fill="#010202"
          />
        </g>
        <g>
          <path
            d="M304.2,190.9h-208.4c-4.4,0-7.9-3.6-7.9-7.9v-43.2c0-4.4,3.6-7.9,7.9-7.9h208.4c4.4,0,7.9,3.6,7.9,7.9v43.2c0,4.4-3.6,7.9-7.9,7.9Z"
            fill="#ffd24a"
          />
          <rect width="42.5" height="59.1" rx="0" ry="0" transform="translate(177.3 131.8)" fill="#72ba63" />
        </g>
      </g>
    </g>
  </g>
</svg>
